<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Track Enquiry Reward Points
        </v-card-title>
        <v-card-text>
          <div v-for="(level, index) in form.pointRange" :key="index">
            <v-row>
              <v-col cols="12" class="d-flex align-center">
                <h4 style="display: inline">Level {{ index + 1 }}</h4>
                <v-btn
                  v-if="form.pointRange.length > 1"
                  icon
                  class="ml-2"
                  color="red"
                  @click="removeLevel(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.min_amount"
                  label="Min Amount"
                  outlined
                  :error-messages="errors.min_amount"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.max_amount"
                  label="Max Amount"
                  outlined
                  :error-messages="errors.max_amount"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.given_points"
                  label="Given Point"
                  outlined
                  :error-messages="errors.given_points"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-btn class="mt-2 mb-4" color="secondary" @click="addLevel">
            <v-icon left>mdi-plus</v-icon>
            Add Next Level
          </v-btn>

          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Track Enquiry Reward Points
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "EnquiryRewardIdPage",
  data() {
    return {
       filter: {
        positionId: null,
        is_active: 1,
      },
      form: {
        is_active: false,
        pointRange: [],
      },
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    addLevel() {
      this.form.pointRange.push({
        min_fieldhero: null,
        max_fieldhero: null,
        points_per_fieldhero: null,
      });
    },
    removeLevel(index) {
      this.form.pointRange.splice(index, 1);
    },
    async getData() {
      this.isLoading = true;
      if (this.$route.params.positionId) {
        this.filter.position_id = this.decryptIt(this.$route.params.positionId);
      } else {
        this.filter.position_id = "";
      }
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "position_id=" +
        this.filter.position_id +
        "&is_active=" +
        this.filter.is_active;
      await axios
        .get(`enquiry_form_reward_points?${query}`)
        .then((response) => {
          this.form.pointRange = response.data.data;
          console.log("giftData", this.form.pointRange);
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        if (this.$route.params.positionId) {
          this.form.position_id = this.decryptIt(this.$route.params.positionId);
        } else {
          this.form.position_id = "";
        }
        console.log(this.form);
        await axios.post(`/enquiry_form_reward_points`, this.form);
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/enquiry_form_reward_points/${this.form.id}`,
          from_name: "EnquiryRewardIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.back();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
